module.exports = __webpack_public_path__ + "static/media/duplicate.01e07273.svg";